const carouselItems = [
  {
    id: 1,
    tag: '暑期档特辑',
    title: '2026 暑期必看十大佳片',
    desc: '从热血动作到治愈动画，这份片单承包你的整个夏天。精选院线热映与平台独播，每一部都值得二刷。',
    img: 'https://readdy.ai/api/search-image?query=Summer%20movie%20marathon%20concept%20with%20warm%20golden%20sunlight%20over%20outdoor%20cinema%20setup%2C%20string%20lights%20and%20cozy%20blankets%2C%20cinematic%20wide%20shot%2C%20festive%20summer%20atmosphere%2C%20professional%20color%20grading%20with%20warm%20amber%20tones%2C%20no%20visible%20text&width=900&height=500&seq=carousel-1-momo&orientation=landscape',
  },
  {
    id: 2,
    tag: '导演专题',
    title: '王家卫的光影世界',
    desc: '重温花样年华、重庆森林等经典之作，感受独树一帜的东方美学与都市情感叙事。',
    img: 'https://readdy.ai/api/search-image?query=Artistic%20cinematic%20composition%20with%20vintage%20Hong%20Kong%20neon%20street%20scene%2C%20rain-slicked%20pavement%20reflecting%20colorful%20lights%2C%20nostalgic%20film%20aesthetic%2C%20warm%20red%20and%20green%20tones%2C%20soft%20focus%20cinematography%20style%2C%20atmospheric%20mood%2C%20no%20text%20or%20faces&width=900&height=500&seq=carousel-2-momo&orientation=landscape',
  },
  {
    id: 3,
    tag: '影史经典',
    title: '豆瓣 TOP50 高分电影巡礼',
    desc: '肖申克的救赎、霸王别姬、阿甘正传……穿梭影史长河，品味永不褪色的银幕传奇。',
    img: 'https://readdy.ai/api/search-image?query=Classic%20film%20tribute%20composition%20with%20vintage%20movie%20projector%20and%20old%20film%20strips%2C%20warm%20sepia%20toned%20lighting%2C%20nostalgic%20cinema%20heritage%20atmosphere%2C%20antique%20theater%20aesthetic%2C%20golden%20hour%20light%20through%20dust%20particles%2C%20no%20text&width=900&height=500&seq=carousel-3-momo&orientation=landscape',
  },
  {
    id: 4,
    tag: '新片速递',
    title: '七月最受期待新片前瞻',
    desc: '多部重量级新作即将登陆，科幻、悬疑、动画全面开花，抢先了解本月观影指南。',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20countdown%20concept%20with%20dramatic%20red%20curtain%20opening%20revealing%20bright%20spotlight%2C%20theater%20stage%20atmosphere%2C%20anticipation%20mood%2C%20warm%20golden%20and%20crimson%20tones%2C%20professional%20film%20lighting%2C%20elegant%20composition%2C%20dark%20background%2C%20no%20text&width=900&height=500&seq=carousel-4-momo&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            <i className="ri-star-line mr-1"></i>编辑精选
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">焦点专题</h2>
          <p className="text-sm text-foreground-500 mt-2 max-w-lg mx-auto">精选优质影视专题内容，深度解读好电影</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {carouselItems.map((item) => (
            <div key={item.id} className="group relative bg-background-50 rounded-xl border border-secondary-200/50 overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-200">
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-accent-500/90 text-white text-xs font-medium">{item.tag}</span>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                <div className="mt-4 flex items-center gap-2 text-primary-600 text-sm font-medium cursor-pointer">
                  <span>查看详情</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}